import { compose, createStore, applyMiddleware } from 'redux';
import { routerMiddleware } from 'react-router-redux';
import createHistory from 'history/createBrowserHistory';
import createSagaMiddleware from '@redux-saga/core';
import rootSaga from '../sagas';
import reducers from '../reducers';
import Types from '../types';
import getPreLoadedState from './preLoadedState';

const history = createHistory();

const init = async () => {
  const reactRouterMiddleware = routerMiddleware(history);
  const sagaMiddleware = createSagaMiddleware();
  const middleware = [reactRouterMiddleware, sagaMiddleware];
  const enhancers = [applyMiddleware(...middleware)];

  /* eslint-disable no-underscore-dangle */
  if (window.__REDUX_DEVTOOLS_EXTENSION__ && process.env.NODE_ENV !== 'production') {
    enhancers.push(window.__REDUX_DEVTOOLS_EXTENSION__());
  }
  /* eslint-enable */

  const enhancer = compose(...enhancers);
  const preLoadedState = await getPreLoadedState();
  const store = createStore(reducers, preLoadedState, enhancer);

  sagaMiddleware.run(rootSaga);
  store.dispatch({
    type: Types.START_APP,
  });

  return store;
};

export default {
  init,
  history,
};
